module.exports = __webpack_public_path__ + "img/mountains-a.3fda26c1.jpg";